/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import { Grid, GridRow, GridColumn } from '@react/react-spectrum/Grid';

import classes from './TopBar.scss';

const TopBar = props => {
    const children = React.Children.toArray(props.children);

    const leftChild = children.find(c => c.props.position === 'left') || null;
    const centerChild = children.find(c => c.props.position === 'center') || null;
    const rightChild = children.find(c => c.props.position === 'right') || null;

    return (
        <Grid className={classes.root}>
            <GridRow valign="middle" className={classes.row}>
                {leftChild && (
                    <GridColumn width="auto" className={classes.left}>
                        {leftChild}
                    </GridColumn>
                )}
                {centerChild && (
                    <GridColumn width="auto" className={classes.center}>
                        {centerChild}
                    </GridColumn>
                )}
                {rightChild && (
                    <GridColumn width="auto" className={classes.right}>
                        {rightChild}
                    </GridColumn>
                )}
            </GridRow>
        </Grid>
    );
};

export default TopBar;
